"use client";

// Gradient house + dollar mark (Figma 8184:57631).

import { useId } from "react";
import type { SVGProps } from "react";

export function BenefitGuaranteeIcon(props: SVGProps<SVGSVGElement>) {
  const gradientId = useId();

  return (
    <svg
      viewBox="0 0 21.4999 19.4295"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      {...props}
    >
      <path
        d="M18.75 7.92945C19.1642 7.92946 19.5 8.26525 19.5 8.67945V16.6795C19.4998 18.1981 18.2687 19.4294 16.75 19.4295H4.74996C3.23126 19.4295 2.00009 18.1981 1.99996 16.6795V8.67945C1.99996 8.26524 2.33575 7.92945 2.74996 7.92945C3.16417 7.92946 3.49996 8.26525 3.49996 8.67945V16.6795C3.50009 17.3697 4.05969 17.9295 4.74996 17.9295H16.75C17.4402 17.9294 17.9998 17.3697 18 16.6795V8.67945C18 8.26524 18.3357 7.92945 18.75 7.92945ZM10.75 4.92945C11.1642 4.92946 11.5 5.26525 11.5 5.67945V6.12965C12.1663 6.26783 12.8133 6.56322 13.2588 6.97438C13.5629 7.25535 13.5816 7.73062 13.3007 8.03492C13.0198 8.33867 12.5454 8.35751 12.2412 8.07691C11.9103 7.77146 11.1997 7.51354 10.5781 7.54371C10.2797 7.55821 10.0897 7.63579 9.98922 7.71754C9.91613 7.77713 9.83297 7.8818 9.83297 8.14137C9.83306 8.23977 9.85583 8.28383 9.87106 8.30738C9.89101 8.33801 9.93486 8.38657 10.0361 8.44605C10.2682 8.58233 10.6101 8.67536 11.0996 8.79859C11.5265 8.90608 12.1012 9.04479 12.5566 9.31227C12.7983 9.45428 13.0419 9.65007 13.2226 9.92945C13.4077 10.2158 13.4999 10.5475 13.5 10.9099C13.4999 11.602 13.2065 12.1618 12.7373 12.5418C12.3767 12.8336 11.9385 12.998 11.5 13.0759V13.6795L11.4961 13.7566C11.4573 14.1345 11.138 14.4294 10.75 14.4295C10.3619 14.4295 10.0426 14.1345 10.0039 13.7566L9.99996 13.6795V13.0398C9.29682 12.8887 8.61573 12.5497 8.16793 11.9988C7.90678 11.6774 7.956 11.2053 8.27731 10.9441C8.59871 10.683 9.07076 10.7312 9.33199 11.0525C9.62784 11.4164 10.3474 11.6874 11.0595 11.6248C11.3967 11.5951 11.646 11.4954 11.7939 11.3757C11.9182 11.275 11.9999 11.1405 12 10.9099C11.9999 10.8118 11.9781 10.7675 11.9629 10.7439C11.943 10.7133 11.8985 10.665 11.7968 10.6052C11.5648 10.469 11.2228 10.3759 10.7334 10.2527C10.3065 10.1452 9.7316 10.0074 9.27633 9.74C9.03467 9.59805 8.79199 9.40109 8.61129 9.12184C8.42613 8.83549 8.33307 8.50388 8.33297 8.14137C8.33297 7.47813 8.58394 6.92758 9.04196 6.55445C9.32836 6.32124 9.66308 6.18503 9.99996 6.11207V5.67945C9.99996 5.26524 10.3357 4.92945 10.75 4.92945ZM10.1464 0.142344C10.5263 -0.0474475 10.9736 -0.0474485 11.3535 0.142344L21.0849 5.00855C21.4552 5.19377 21.6058 5.64404 21.4209 6.01441C21.2356 6.3846 20.7853 6.53518 20.415 6.35035L10.75 1.51832L1.08492 6.35035C0.714595 6.5352 0.26429 6.3846 0.0790651 6.01441C-0.105863 5.64403 0.0447058 5.19376 0.415003 5.00855L10.1464 0.142344Z"
        fill={`url(#${gradientId})`}
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="21.4518"
          y1="19.4292"
          x2="-2.33775"
          y2="15.9405"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.030303" stopColor="#FE634D" />
          <stop offset="0.111111" stopColor="#F74B81" />
          <stop offset="0.191919" stopColor="#E040B4" />
          <stop offset="0.272727" stopColor="#CE3CC9" />
          <stop offset="0.353535" stopColor="#B734DB" />
          <stop offset="0.434343" stopColor="#A62FE6" />
          <stop offset="0.515152" stopColor="#942AEF" />
          <stop offset="0.59596" stopColor="#8125F6" />
          <stop offset="0.676768" stopColor="#6B20FC" />
          <stop offset="0.757576" stopColor="#511DFF" />
          <stop offset="0.838384" stopColor="#2E1DFF" />
          <stop offset="1" stopColor="#001EFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
